<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        {{this.Filter.EmpType === 'front'? 'Employee attendance merge Front':'Employee attendance merge Back'}}
    </div>
    <form name="ApprovalDetails" (ngSubmit)="Validate(ApprovalDetails)" #ApprovalDetails="ngForm" class="pb-2"
        novalidate>
        <div class="card-body">
            <div class="row d-flex">
                <div class="col-md-5 px-1">
                    <label class="form-font-label">Branch</label>
                    <ng-select name="Branchmaster" id="Branchmaster" [items]="BranchMaster" bindLabel="BranchName"
                        bindValue="BranchMasterID" [(ngModel)]="Filter.BranchID"
                        (change)="ComboLoad('Client');onSelectChange('Branch')" #Branchmaster="ngModel"
                        placeholder="Select Branch">
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select Branch!
                    </div>
                </div>
                <div class="col-md-6 px-1" *ngIf="Filter.EmpType === 'front'">
                    <label class="form-font-label">Client</label>
                    <ng-select name="Client" id="Client" [items]="ClientMaster" bindLabel="ClientGroupName"
                        bindValue="ClientGroupMasterID" (change)="ComboLoad('Site');onSelectChange('Client')"
                        [(ngModel)]="Filter.ClientID" #Branch="ngModel" placeholder="Select Client">
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select Client!
                    </div>
                </div>
                <div class="col-md-7 px-1" *ngIf="Filter.EmpType === 'front'">
                    <label class="form-font-label">Site</label>
                    <ng-select name="Site" id="Site" [items]="SiteMaster" bindLabel="SiteName" bindValue="SiteMasterID"
                        [(ngModel)]="Filter.SiteID" #Branch="ngModel" (change)="onSelectChange('Site')"
                        placeholder="Select Site">
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select Site!
                    </div>
                </div>
                <div class="col-md-3 px-1">
                    <label>Code </label>
                    <input name="Code" maxlength="100" class="form-control" placeholder="Ex."
                        [(ngModel)]="Filter.EmpCode" #Code="ngModel">
                    <div class="invalid-feedback">
                        Please enter Code.
                    </div>
                </div>
                <div class="col-md-2 px-1 d-flex align-items-end">
                    <button *ngIf="this.common.PageRight.IsPrint" type="submit" name="submit1" class="btn btn-primary"
                        [disabled]="isDisabled">
                        <i class="bi bi-search" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled ? 'Search' : 'Loading...'}}
                    </button>
                </div>
            </div>
            <div>
                <div class="card border-radius-0 mt-1 p-0">
                    <div class="card-header">
                        Employee List
                    </div>
                    <div class="card-body p-1" style="overflow: auto;">
                        <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                            class="customeDatatable table table-bordered">
                            <thead class="table-light">
                                <tr>
                                    <th scope="col" style="width: 5px;">#</th>
                                    <th scope="col" style="width: 10px;">Emp Code</th>
                                    <th scope="col">Employee Name</th>
                                    <th scope="col" style="width: 5px;">
                                        <input type="checkbox" name="all" (change)="selectAll($event)">
                                        <!-- <input type="checkbox" name="all" (change)="selectAll($event)"> -->
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let shift of TableDatas; let i = index">
                                    <th scope="row">{{ i + 1 }}</th>
                                    <td style="width: 10px;">{{ shift['EmpCode']}}</td>
                                    <td>{{ shift['EmployeeName']}}</td>
                                    <td>
                                        <input type="checkbox" [(ngModel)]="shift.selected" name="row{{i}}"
                                            (change)="selectRow($event, shift)">
                                        <!-- <input type="checkbox" [(ngModel)]="shift.selected" name="row{{i}}"
                                            (change)="selectRow($event, shift)"> -->
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="button" name="Print" class="btn btn-primary" [disabled]="isDisabled" (click)="Save()"><i
                        class="bi bi-save" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}</button>
            </div>
        </div>
    </form>
</div>